import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Spin } from "antd";
import { toast } from "react-toastify";
import { dependenciasApi } from "../../services/api";

const DependenciaFormModal = ({ visible, onCancel, onSuccess, editingDependencia }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const isEditing = !!editingDependencia;

  useEffect(() => {
    if (visible && isEditing) {
      // Completar formulario con datos existentes si estamos editando
      form.setFieldsValue({
        dependencia: editingDependencia.dependencia,
      });
    } else if (visible) {
      // Limpiar formulario si estamos creando
      form.resetFields();
    }
  }, [visible, editingDependencia, form, isEditing]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      if (isEditing) {
        // Actualizar dependencia existente
        await dependenciasApi.update(editingDependencia.id, values);
        toast.success("Dependencia actualizada correctamente", {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        // Crear nueva dependencia
        await dependenciasApi.create(values);
        toast.success("Dependencia creada correctamente", {
          position: "top-right",
          autoClose: 4000,
        });
      }

      setLoading(false);
      onSuccess();
    } catch (error) {
      console.error("Error al guardar dependencia:", error);
      let errorMsg = "Error al guardar los datos";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMsg = error.response.data.message;
      }
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 4000,
      });
      setLoading(false);
    }
  };

  return (
    <Modal
      title={isEditing ? "Editar Dependencia" : "Nueva Dependencia"}
      open={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      maskClosable={false}
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="mt-4"
        >
          <Form.Item
            label="Nombre de la Dependencia"
            name="dependencia"
            rules={[
              {
                required: true,
                message: "Por favor ingrese el nombre de la dependencia",
              },
            ]}
          >
            <Input placeholder="Ej: Sistemas" />
          </Form.Item>

          <div className="flex justify-end gap-2 mt-6">
            <Button onClick={onCancel}>Cancelar</Button>
            <Button
              type="primary"
              htmlType="submit"
              className="bg-blue-600 hover:bg-blue-700"
            >
              {isEditing ? "Actualizar" : "Crear"}
            </Button>
          </div>
        </Form>
      </Spin>
    </Modal>
  );
};

export default DependenciaFormModal;